export default __webpack_public_path__ + "static/media/devl.1375939d.jpg";